import { UserStatus } from "../types/UserStatus";

export const userStatus:UserStatus[]=
[
    {value:true,label:"Actif"},
    {value:false,label:"Inactif"}
]